import { RootState } from 'store';

export const walletPaymentMethodSelector = (state: RootState) =>
  state.wallet.paymentMethod;
export const walletPaymentMethodPendingSelector = (state: RootState) =>
  state.wallet.pending.paymentMethod;
export const walletCardsSelector = (state: RootState) => state.wallet.cards;
export const walletCardsPendingSelector = (state: RootState) =>
  state.wallet.pending.cards;
export const walletCardsErrorSelector = (state: RootState) =>
  state.wallet.errors.cards;
export const walletTransactionsPendingSelector = (state: RootState) =>
  state.wallet.pending.transactions;
export const walletStripeWalletSelector = (state: RootState) =>
  state.wallet.stripeWallet;
export const walletCheckoutSessionSelector = (state: RootState) =>
  state.wallet.checkoutSession;
export const walletCheckoutSessionPendingSelector = (state: RootState) =>
  state.wallet.pending.checkoutSession;
